module.exports = __webpack_public_path__ + "static/img/国外影城一瞥- banner (1).db91232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listitem/国外影城一瞥- banner (1).png
// module id = 829
// module chunks = 0